import styled from 'styled-components';
import { motion } from 'framer-motion';

export const DeckContainer = styled(motion.div)`
  display: grid;
  /* 4 columns on desktop */
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 250px; /* Base height for standard grid cells */
  gap: 1rem;
  width: 100%;
  max-width: 1200px; /* Keep it aligned with your main container */
  margin: 2rem auto 4rem auto;

  /* Tablet - collapse to 2 columns */
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 220px;
  }

  /* Mobile - collapse to 1 column */
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-auto-rows: 280px;
  }
`;

export const DeckIntro = styled.p`
  color: var(--secondary-text);
  max-width: 600px;
  margin: 4rem auto 1.5rem auto; 
  font-family: var(--font-body);
  line-height: 1.6;
  font-size: 0.95rem; 
  text-align: center;
`;